import { useState } from "react";
import { useTranslation } from "../localization/useTranslation";
import { ICustomListsProps } from "./CustomLists";
import { CallPage, CustomListsViewModel, CustomListType } from "./CustomLists.types";
import { useUrlProvider } from "../useUrlProvider";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";

import { useDotLegalQuery, useDotLegalQueryClient, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useCustomLists(props: ICustomListsProps) {
    const { getProcessingActivitiesOverviewUrl, getExternalLegalEntities, getSystemsUrl, getGroupEntitiesUrl } = useUrlProvider();
    const queryClient = useDotLegalQueryClient();
    const { translateString, translateCustomListType } = useTranslation();
    const [selectedCustomList, setSelectedCustomList] = useState({ show: false, description: "", name: "", id: "", copy: false });
    const [showDeleteDialog, setShowDeleteDialog] = useState({ show: false, id: "", name: "" });
    const key = "lists" + props.listType;
    const { isLoading, data } = useDotLegalQueryWithKey<Array<CustomListsViewModel>>(key, `/CustomLists/${props.listType}/overview`);
    const hasLists = isLoading ? true : data?.length! > 0;

    const refetchLists = () => {
        queryClient.refetchQueries(key);
    };

    const getBreadCrumbs = () => {
        let breadCrumbs = getFirstBreadCrumbs();

        breadCrumbs.push({ name: `${translateString("customLists")} - ${translateCustomListType(props.listType.toString())}` });
        return breadCrumbs;
    };

    function getFirstBreadCrumbs(): Array<DotLegalBreadCrumbModel> {
        switch (props.listType) {
            case CustomListType.Company: {
                if (props.callPage === CallPage.GroupCompanies) {
                    return [{ name: translateString("groupEntities"), link: getGroupEntitiesUrl() }];
                }
                return [{ name: translateString("companies"), link: getExternalLegalEntities() }];
            }
            default:
                return [{ name: translateString("processingActivities"), link: getProcessingActivitiesOverviewUrl() }];
        }
    }

    return {
        hasLists,
        data,
        isLoading,
        selectedCustomList,
        setSelectedCustomList,
        refetchLists,
        showDeleteDialog,
        setShowDeleteDialog,
        getBreadCrumbs,
    };
}
